import * as React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';

const SEPlayLink = ({ imageGalleryUrl, labels, completeUrl }) => {
    return (
        <>
            <Grid item xs={7} sm={3}>
                <Link
                    sx={{ cursor: 'pointer', color: 'secondary', textDecoration: 'none' }}
                    href={imageGalleryUrl}
                    target="_blank"
                    role="link"
                >
                    {labels.linkLabel}
                </Link>
            </Grid>
            <Grid item xs={5} sm={4}>
                <Tooltip
                    componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
                    title={`${labels.tooltipLabel}`}
                >
                    <ContentCopyIcon
                        role="icon"
                        aria-label={'copy-icon'}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => navigator['clipboard'].writeText(`${completeUrl}`)}
                    />
                </Tooltip>
            </Grid>
        </>
    );
};

export default SEPlayLink;
